// extracted by mini-css-extract-plugin
export var defaultWrapper = "_nc-3";
export var downloadButton = "_nc-4";
export var fileContainer = "_nc-9 _nc-7";
export var fileContainerBase = "_nc-7";
export var fileContainerFixedHeight = "_nc-8 _nc-7";
export var fileInfo = "_nc-5";
export var fileInfoWidthRestricted = "_nc-6";
export var fileType = "_nc-1";
export var fileTypeName = "_nc-2";
export var image = "_nc-0";
export var link = "_nc-b";
export var overflowEllipsis = "_nc-a";